<template>
    <div class="fu">
        <span>退款数量:</span>
        <el-input class="input" placeholder="请输入退款数量" clearable v-model="refundNum"></el-input>
        <div class="button">
                <el-button style="margin-right: 20px;" type="primary" @click="onSubmit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
        </div>

    </div>
</template>

<script>
    //import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'refundNumber',
        props:{

        },
        data(){
            return{
                refundNum:'',
            }
        },
        watch:{
        },
        mounted(){
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),


            // //业务配置保存
            // async save() {
            //     // console.log(this.editData.type)
            //     // return
            //     if(!this.editData.type){
            //         this.editData.type=0
            //     }
            //     if(parseFloat(this.editData.upperBound)!==''&&parseFloat(this.editData.lowerBound)!==''){
            //         if(parseFloat(this.editData.upperBound) <= parseFloat(this.editData.lowerBound)){
            //             this.$message({
            //                 message: '下限大于上限，请重新输入',
            //                 type: 'error'
            //             });
            //             return
            //         }
            //     }
            //
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         id:this.editData.id,
            //         no:this.editData.no,
            //         name:this.editData.name,
            //         inputTitle:this.editData.inputTitle,
            //         inputType:this.editData.inputType,
            //         inputUnit:this.editData.inputUnit,
            //         upperBound:this.editData.upperBound,
            //         lowerBound:this.editData.lowerBound,
            //         inputWidth:this.editData.inputWidth,
            //         dcsWidth:this.editData.dcsWidth,
            //         pid:this.editData.pid,
            //         orderNo:this.editData.orderNo,
            //         type:this.editData.type
            //     }
            //     for(let i in params){
            //         if(params[i]===''){
            //             delete params[i]
            //         }
            //     }
            //     // console.log(params)
            //     // return
            //     let res = await API.save(params);
            //     if (res.code == 1) {
            //         this.$emit('list')
            //         this.$emit('close')
            //         this.$message({
            //             message: res.message,
            //             type: 'success'
            //         });
            //
            //     } else if (res.code == -2) {
            //
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else if (res.code == -1){
            //         this.editData.beginTime=''
            //         this.$message({
            //             message:res.message,
            //             type:'warning'
            //         })
            //     }else {
            //         this.editData.beginTime=''
            //         this.$message.error(res.message);
            //
            //     }
            // },
            close(){
                this.$emit('close')
            },

            onSubmit(){


            },


        }
    }
</script>
<style lang="scss" scoped>
    .fu{
        text-align: center;
    }
    .fu span{
        margin-right:10px;
    }
    .input{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .button{
        margin-top: 30px;
    }
</style>